import React, { VoidFunctionComponent } from 'react';
import { ImageSizes, MediaSizes, LoadingMechanism} from "@/models/scope/productSheet/ProductImages";
import { FILE_FORMAT_REGEX, PHOTO_SIZE } from "@/utils/constants";

interface Props {
  url: string;
  alt?: string;
  isLazy: boolean;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const ResponsivePicture: VoidFunctionComponent<Props> = ({ url, alt = "", isLazy, onClick }) => {

  if (!url) {
    return null;
  }

  const format = url.match(FILE_FORMAT_REGEX);
  const type = `image/${format}`;
  const loading = isLazy ? LoadingMechanism.LAZY : LoadingMechanism.EAGER;

  const replaceImageSize = (url: string, size: string): string => {
    return url.replace(PHOTO_SIZE, `p-${size}`);
  };

  return (
    <picture onClick={onClick}>
      <source
        srcSet={replaceImageSize(url, ImageSizes.XXL)}
        type={type}
        media={MediaSizes.XXL}
      />
      <source
        srcSet={replaceImageSize(url, ImageSizes.XL)}
        type={type}
        media={MediaSizes.XL}
      />
      <source
        srcSet={replaceImageSize(url, ImageSizes.L)}
        type={type}
        media={MediaSizes.L}
      />
      <img
        src={replaceImageSize(url, ImageSizes.XL)}
        alt={alt}
        loading={loading}
      />
    </picture>
  );
};